"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _Edit = _interopRequireDefault(require("@mui/icons-material/Edit"));
var _Delete = _interopRequireDefault(require("@mui/icons-material/Delete"));
var _sbUtils = require("@simplybenefits/sb-utils");
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _theme = require("../../theme");
var _Text = _interopRequireDefault(require("../../components/Text"));
var _Button = _interopRequireDefault(require("../../components/Button"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var EntityTable = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(EntityTable, _PureComponent);
  function EntityTable() {
    (0, _classCallCheck2["default"])(this, EntityTable);
    return _callSuper(this, EntityTable, arguments);
  }
  (0, _createClass2["default"])(EntityTable, [{
    key: "render",
    value: function render() {
      var _this = this;
      var items = this.props.items;
      var styles = {
        block: {
          backgroundColor: _theme.colors.surface,
          boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
          height: 'auto'
        },
        header: {
          display: 'flex',
          flexDirection: 'row',
          flex: 1,
          alignItems: 'center',
          padding: '10px 30px 10px 30px'
        },
        row: {
          display: 'flex',
          flexDirection: 'row',
          flex: 1,
          alignItems: 'center',
          paddingTop: 10,
          paddingBottom: 10,
          borderTop: "1px solid #eee",
          padding: '10px 30px 10px 30px'
        },
        title: {
          width: '25%'
        },
        description: {
          width: '35%'
        },
        effDate: {
          width: '20%'
        },
        actions: {
          display: "flex",
          alignItems: "flex-end",
          flexDirection: "row",
          justifyContent: "flex-end",
          width: '20%'
        }
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.block
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.header
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.title
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        bold: true
      }, _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.name))), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.description
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        bold: true
      }, _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.description))), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.description
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        bold: true
      }, _i18n["default"].t(_tokens["default"].labels.effectiveDate)))), _sbUtils.helpers.sortObjByTitle(items).map(function (id) {
        var item = items[id];

        // if it's modular flex we only want to show the parent class
        if (item.isModular && item.parentClassID !== null) {
          return null;
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: styles.row,
          key: id
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: styles.title
        }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          medium: true,
          light: true
        }, item.title)), /*#__PURE__*/_react["default"].createElement("div", {
          style: styles.description
        }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          medium: true,
          light: true
        }, item.description)), item.classEffectiveDate ?
        /*#__PURE__*/
        // this displays the class and division Effective dates only if the account is not pending - there are tripled up ternaries because it handles revision data, quote data, pending data and live data
        _react["default"].createElement("div", {
          style: styles.effDate
        }, item.status === undefined && item.isNew === undefined ? /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          medium: true,
          light: true,
          customStyle: {
            paddingLeft: "40px"
          }
        }, "-") : /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          medium: true,
          light: true
        }, dates.getStartOfDay(item.classEffectiveDate, "ll"))) : item.eligibilityOverrideDate ? /*#__PURE__*/_react["default"].createElement("div", {
          style: styles.effDate
        }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          medium: true,
          light: true
        }, dates.getStartOfDay(item.eligibilityOverrideDate, "ll"))) : /*#__PURE__*/_react["default"].createElement("div", {
          style: styles.effDate
        }, item.status === undefined && item.isNew === undefined ? /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          medium: true,
          light: true,
          customStyle: {
            paddingLeft: "40px"
          }
        }, "-") : /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          medium: true,
          light: true
        }, dates.getStartOfDay(item.accountEffectiveDate, "ll"))), /*#__PURE__*/_react["default"].createElement("div", {
          style: styles.actions
        }, _this.props.edit && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          onClick: function onClick() {
            return _this.props.edit(item);
          },
          transparent: true
        }, /*#__PURE__*/_react["default"].createElement(_Edit["default"], {
          style: {
            fontSize: 17,
            lineHeight: '14px',
            color: 'inherit'
          }
        })), _this.props.remove && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          onClick: function onClick() {
            return _this.props.remove(item);
          },
          transparent: true
        }, /*#__PURE__*/_react["default"].createElement(_Delete["default"], {
          style: {
            fontSize: 17,
            lineHeight: '14px',
            color: 'inherit'
          }
        }))));
      }));
    }
  }]);
  return EntityTable;
}(_react.PureComponent);
var _default = exports["default"] = EntityTable;